import { getParameterByName } from "./helperFunctions";

import "./../_polyfill/Promise";
import "./../_polyfill/Array_find";
import "./../_polyfill/Array_from";

export default class TaxonomyList {
    // Inititialize TaxonomyList for a selection of lists
    static init(querySelector = ".item-list[data-source-id]") {
        Array.prototype.forEach.call(
            document.querySelectorAll(querySelector),
            element => {
                new TaxonomyList(element);
            }
        );
    }

    constructor(element) {
        this.element = element;
        this.dataSourceId = element.getAttribute("data-source-id");
        this.dataApi = element.getAttribute("data-api-url");
        this.currentPageId = element.getAttribute("data-current-page-id");
        this.tags = element.getAttribute("data-tags");
        this.amountOfPromotedListItems = element.getAttribute(
            "data-amount-of-promoted-list-items"
        );
        this.colSize = element.getAttribute("data-col-size");
        this.hideSummary = element.getAttribute("data-hide-summary") === "True";
        this.hideDate = element.getAttribute("data-hide-date") === "True";
        this.maxNumberOfTagsShown = element.getAttribute(
            "data-max-number-of-tags-shown"
        );
        this.hideTags = element.getAttribute("data-hide-tags") === "True";
        this.groupBy = element.getAttribute("data-group-by");
        this.showGroupsCondensed = element.getAttribute(
            "data-show-groups-condensed"
        );
        this.listType = element.getAttribute("data-list-type");
        this.moduleSummary = element.getAttribute("data-module-summary");
        this.moduleTitle = element.getAttribute("data-module-title");
        this.sExcludedItems = element.getAttribute("data-excluded-items");
        this.loadMoreElement = element.parentElement.querySelector(
            ".list-load-more"
        );
        this.loader = element.parentElement.querySelector(".list-loader");
        this.listFiltersElement = element.parentElement.querySelector(
            ".list-filters"
        );
        this.language = document.getElementsByTagName('html')[0].getAttribute("lang")
        this.hostName = window.location.host

        this.excludedItems = [];
        this.groups = [];
        this.items = [];
        this.page = 0;
        this.totalNumber = 0;
        this.filterTags = [];
        this.dynamicFilters = [];
        this.taxonomyDropdownFilters = [];

        // Load more items when load-more is clicked
        if (this.loadMoreElement) {
            this.loadMoreElement.addEventListener("click", () =>
                this.populate()
            );
        }

        // Filter and reload items with new parameters when the filter-button is clicked
        if (this.listFiltersElement) {
            this.listFiltersElement
                .querySelector(".event-list-filter-button button")
                .addEventListener("click", event => {
                    event.preventDefault();

                    this.filterTags = Array.from(
                        this.listFiltersElement.querySelectorAll(
                            ".event-list-filter.tags-filter option:selected"
                        )
                    )
                        .map(filterElement => {
                            return filterElement.value;
                        })
                        .filter(x => x !== "");
                    this.dynamicFilters = Array.from(
                        this.listFiltersElement.querySelectorAll(
                            ".event-list-filter.dynamic-filter option:selected"
                        )
                    )
                        .map(filterElement => {
                            return {
                                Key: filterElement.name,
                                Value: filterElement.value
                            };
                        })
                        .filter(x => x.Value !== "");

                    this.clearItems();
                    this.populate();
                });
        }

        this.taxonomyDropdown = document.querySelector(
            ".module-taxonomy-dropdown-body"
        );
        if (this.taxonomyDropdown) {
            this.taxonomyDropdown
                .querySelector("form")
                .addEventListener("submit", event => {
                    event.preventDefault();
                    setTimeout(() => {
                        this.clearItems();
                        this.populate();
                    });
                });
        }

        /*
         * Load initial first batch of items.
         */
        this.populate();
    }

    populate() {
        if (this.totalNumber === 0) {
            this.loader.style.display = "";
        }
        this.loadMoreElement.classList.add("pending");
        //this.loadMoreElement.classList.remove('list-load-more-hidden')
        this.requestTaxonomyList(this.page++).then(data => {
            this.loader.style.display = "none";
            this.loadMoreElement.classList.remove("pending");

            /*
             * Push new groups to current array.
             */
            data.Groups.forEach(newGroup => {
                var exsistingGroup = this.groups.find(
                    x => x.GroupKey === newGroup.GroupKey
                );

                if (exsistingGroup !== undefined) {
                    newGroup.Items.forEach(newItem =>
                        exsistingGroup.Items.push(newItem)
                    );
                } else {
                    this.groups.push(newGroup);
                }
            });

            /*
             * We keep an array over all the items without grouping so we can check length etc. without having to flatten every time.
             */
            this.items = this.items.concat(
                data.Groups.reduce(
                    (items, group) => items.concat(group.Items),
                    []
                )
            );

            /*
             * Render the entire list again with the new data added
             * DOM-performance could be improved by only rendering the newly added items
             */
            this.render(this.element, this.groups);

            /*
             * Add totalNumber AFTER render, so new elements can animate in.
             */
            this.totalNumber = data.TotalNumber;

            /*
             * Should we hide the load-more button.
             */
            if (this.totalNumber <= this.items.length) {
                this.loadMoreElement.classList.add("list-load-more-hidden");
            } else {
                this.loadMoreElement.classList.remove("list-load-more-hidden");
            }

            /*
             * Should the list be shown at all?
             */

            if (this.totalNumber === 0) {
                $(this.element)
                    .closest(".module")
                    .addClass("taxonomy-list--no-results");
            } else {
                $(this.element)
                    .closest(".module")
                    .removeClass("taxonomy-list--no-results");
            }
        });
    }
    clearItems() {
        this.groups = [];
        this.items = [];
        this.page = 0;
        this.totalNumber = 0;
        this.element.innerHTML = "";
        this.loadMoreElement.classList.add("list-load-more-hidden");
    }
    requestTaxonomyList(pageIndex) {
        var taxonomyDropdownFilters = [];
        var pattern = /(\d{2})\-(\d{2})\-(\d{4})/;
        if (getParameterByName("filter")) {
            taxonomyDropdownFilters = getParameterByName("filter")
                .split(" ")
                .filter(x => x !== "");
        }

        var FilterTags =
            this.filterTags.concat(taxonomyDropdownFilters).length > 0
                ? this.filterTags.concat(taxonomyDropdownFilters)
                : [];
        var Year = getParameterByName("year")
            ? getParameterByName("year")
            : undefined;
        var FromDate = getParameterByName("fromDate")
            ? new Date(
                  getParameterByName("fromDate").replace(pattern, "$3-$2-$1")
              )
            : undefined;
        var ToDate = getParameterByName("toDate")
            ? new Date(
                  getParameterByName("toDate").replace(pattern, "$3-$2-$1")
              )
            : undefined;
        var Filters = this.dynamicFilters ? this.dynamicFilters : undefined;

        if (
            this.sExcludedItems != null &&
            this.sExcludedItems.indexOf(",") > -1
        ) {
            this.sExcludedItems = this.sExcludedItems.replace(/,\s*$/, "");
            this.excludedItems = this.sExcludedItems.split(",");
        } else if (!this.sExcludedItems == "") {
            this.excludedItems.push(this.sExcludedItems);
        }

        return new Promise((resolve, reject) => {
            jQuery.ajax({
                type: "POST",
                url: `${this.dataApi}&sc_itemid=${this.currentPageId}`, // /api/taxonomylist/Search
                data: JSON.stringify({
                    Id: this.dataSourceId,
                    DropdownDataSourceId:
                        "{10A8301B-B29F-4BC1-98CF-199220F287DF}", //TODO .module-taxonomy-dropdown-body data-source-id
                    Page: pageIndex,
                    Tags: this.tags,
                    ExcludedItems: this.excludedItems,
                    FilterTags,
                    Filters,
                    Year,
                    FromDate,
                    ToDate,
                    Language: this.language,
                    Host: this.hostName
                }),
                success: resolve,
                failure: reject,
                dataType: "json",
                contentType: "application/json"
            });
        });
    }

    render(containerElement, groupsToRender) {
        var itemIndex = 0;
        containerElement.innerHTML = "";
        groupsToRender.forEach(group => {
            if (this.groupBy === "True") {
                var groupElement = document.createElement("span");
                groupElement.classList.add("col-12");
                groupElement.innerHTML = `<h2 class="list-group-header">
                        ${group.GroupLabel ? group.GroupLabel : ""}
                    </h2>`;

                containerElement.appendChild(groupElement);
            }
            group.Items.forEach(item => {
                itemIndex++;

                var itemElement = document.createElement("li");
                itemElement.classList.add("col-12");
                // Add colSize classes to element
                if (itemIndex <= this.amountOfPromotedListItems) {
                    itemElement.classList.add("list-item-promoted");
                } else {
                    this.colSize
                        .split(" ")
                        .forEach(x => itemElement.classList.add(x));
                }

                itemElement.style.opacity =
                    itemIndex >= this.totalNumber ? 0 : 1;
                itemElement.style.transition = `opacity 500ms ease-in`;

                var primaryTags = "";
                var secondaryTagsArray;
                var secondaryTags = "";

                if (
                    this.maxNumberOfTagsShown &&
                    this.maxNumberOfTagsShown != 0
                ) {
                    primaryTags = item.Tags.slice(0, this.maxNumberOfTagsShown)
                        .map(
                            tag => `
                                <span class="list-item-tag" tabindex="0" data-link-url="${tag.Url}">${tag.Text}</span>
                            `
                        )
                        .join("");

                    secondaryTagsArray = item.Tags.slice(
                        this.maxNumberOfTagsShown
                    );
                    secondaryTags = secondaryTagsArray
                        .map(
                            tag => `
                                <span class="list-item-tag list-item-tag-hidden" tabindex="0" data-link-url="${tag.Url}">${tag.Text}</span>
                            `
                        )
                        .join("");
                } else {
                    primaryTags = item.Tags.map(
                        tag => `
                                <span class="list-item-tag" tabindex="0" data-link-url="${tag.Url}">${tag.Text}</span>
                            `
                    ).join("");
                }
                itemElement.innerHTML = `<a href="${
                    item.Url
                }" class="list-link-item">
                    <div class="list-item-image-container responsive-background" style="background-image: none">
                        ${
                            itemElement.classList.contains("list-item-promoted")
                                ? item.PageImageResponsiveHTML
                                : itemElement.classList.contains("col-half")
                                ? item.PageImageResponsiveHalfHTML
                                : item.PageImageResponsiveThirdHTML
                        }
                    </div>

                    ${
                        item.PageIcon
                            ? `<span class ="list-item-icon"><img src="${item.PageIcon}" alt="" /></span>`
                            : `<span class ="list-item-icon ${item.FontAwesomePageIconName}"></span>`
                    }
                
                    <div class="list-item-inner">
                        <h2 class="list-item-title-container ${
                            item.PageTitlePrefix ? "" : "no-info-text"
                        } ${
                    item.Tags.length > 0 && this.hideTags == false
                        ? "has-tags"
                        : ""
                }" >
                            ${
                                item.PageTitlePrefix
                                    ? `<span class="list-item-info-prefix">${item.PageTitlePrefix}</span>`
                                    : ""
                            }
                            <span class="list-item-title">${
                                item.PageTitle
                            }</span>
                        </h2>

                        ${
                            item.Tags.length > 0 && this.hideTags == false
                                ? `
                            <div class="list-item-info-text">

                            ${primaryTags}

                            ${
                                secondaryTags.length > 0
                                    ? `
                                <span class="list-item-info-text-secondary">
                                ${secondaryTags}
                                </span>
                                <span class="list-item-tag-toggle" tabindex="0" data-link-url="">
                                    +${secondaryTagsArray.length}
                                    <span class="sr-only">tags</span>
                                </span>
                                
                                `
                                    : ""
                            }

                            </div>
                        `
                                : ""
                        }

                        ${
                            this.hideSummary
                                ? ""
                                : `<div class="list-item-summary">${item.PageSummary}</div>`
                        }
                        ${
                            this.hideDate == false &&
                            this.listType === "news-list" &&
                            item.NewsDate
                                ? `<div class="list-item-date">${new Date(
                                      item.NewsDate
                                  ).toString("{dd}.{MM}.{yyyy}")}</div>`
                                : ""
                        }
                        ${
                            this.hideDate == false &&
                            this.listType === "event-list" &&
                            item.StartDate &&
                            item.EndDate
                                ? `<div class="list-item-date">${new Date(
                                      item.StartDate
                                  ).toString("{dd}.{MM}.{yyyy}")} - ${new Date(
                                      item.EndDate
                                  ).toString("{dd}.{MM}.{yyyy}")}</div>`
                                : ""
                        }
                        ${
                            this.hideDate == false &&
                            this.listType === "" &&
                            item.Date
                                ? `<div class="list-item-date">${new Date(
                                      item.Date
                                  ).toString("{dd}.{MM}.{yyyy}")}</div>`
                                : ""
                        }
                        <span class="list-link-readmore">Read more</span>
                    </div>
                </a>`;

                containerElement.appendChild(itemElement);

                Array.prototype.forEach.call(
                    itemElement.querySelectorAll("span.list-item-tag"),
                    tagItem => {
                        var linkUrl = tagItem.getAttribute("data-link-url");
                        tagItem.addEventListener("click", event => {
                            event.preventDefault();
                            window.location = linkUrl;
                        });
                        tagItem.addEventListener("keypress", event => {
                            if (event.which == 13 || event.which == 32) {
                                event.preventDefault();
                                window.location = linkUrl;
                            }
                        });
                    }
                );
                Array.prototype.forEach.call(
                    itemElement.querySelectorAll("span.list-item-tag-toggle"),
                    toggleItem => {
                        toggleItem.addEventListener("click", event => {
                            event.preventDefault();
                            toggleItem.style.display = "none";
                            toggleItem.parentElement.querySelector(
                                "span.list-item-info-text-secondary"
                            ).style.display = "inline";
                        });
                        toggleItem.addEventListener("keypress", event => {
                            if (event.which == 13 || event.which == 32) {
                                event.preventDefault();
                                toggleItem.style.display = "none";
                                toggleItem.parentElement.querySelector(
                                    "span.list-item-info-text-secondary"
                                ).style.display = "inline";
                            }
                        });
                    }
                );

                setTimeout(
                    function() {
                        itemElement.style.opacity = 1;
                        var imgForUpdate = itemElement.querySelector("img");
                        if (
                            imgForUpdate !== null &&
                            imgForUpdate !== "undefined"
                        ) {
                            window.bLazy.load(
                                itemElement.querySelector("img"),
                                true
                            );
                        }
                    },
                    itemIndex >= this.totalNumber
                        ? ~~(Math.sqrt(itemIndex) * 115)
                        : 0
                );
            });
        });
    }
}

$(document).ready(function() {
    $(".module-manual-list span.list-item-tag").each(function() {
        var itm = $(this);
        var linkUrl = itm.attr("data-link-url");

        itm.click(function(event) {
            event.preventDefault();
            window.location = linkUrl;
        });

        itm.keypress(function(event) {
            if (event.which == 13 || event.which == 32) {
                event.preventDefault();
                this.click();
            }
        });
    });

    $(".module-manual-list span.list-item-tag-toggle").each(function() {
        var itm = $(this);

        itm.click(function(event) {
            event.preventDefault();
            itm.hide();
            itm.parent()
                .find("span.list-item-info-text-secondary")
                .attr("style", "display: inline");
        });

        itm.keypress(function(event) {
            if (event.which == 13 || event.which == 32) {
                event.preventDefault();
                this.click();
            }
        });
    });
});
